import { Step1WritingMetadata, isStep1PathSelected } from '../types/step1Writing';
import { modeLabel } from '../utils/step1WritingLabels';
import { formatAloudDurationLabel, formatWordCountLabel } from '../utils/readTimeEstimate';
import { getActiveLocale, t } from '../i18n/translate';

/** One-line progress summary for Action 3 (only when a method is selected). */
export function formatStep1ProgressLine(metadata: Step1WritingMetadata): string {
  if (!isStep1PathSelected(metadata)) return '';

  const parts: string[] = [modeLabel(metadata.mode)];

  if (metadata.wordCount && metadata.wordCount > 0) {
    parts.push(formatWordCountLabel(metadata.wordCount));
    const aloud = formatAloudDurationLabel(metadata.wordCount);
    if (aloud) parts.push(aloud);
  } else if (metadata.hasContent) {
    parts.push(t('step.1.progress.in_progress'));
  } else {
    parts.push(t('step.1.progress.started'));
  }

  if (metadata.lastWorkedAt) {
    const d = new Date(metadata.lastWorkedAt);
    parts.push(
      t('step.1.progress.last_worked', {
        date: d.toLocaleDateString(getActiveLocale(), { month: 'short', day: 'numeric' }),
      })
    );
  }

  return parts.join(' · ');
}
